/** All amounts use USD/lb unless named as a shipment total, per-bag charge, or percentage. */
export function handlingBreakdown(data: any): any {
  const pounds = Number(data.netWeight);
  const bags = Number(data.totalBags ?? data.BagsOrdered ?? 0);
  const cost = Number(data.cost ?? 0);
  const totalCost = Number(data.totalCost ?? cost * pounds);
  const divide = (amount: number) => pounds > 0 ? amount / pounds : 0;
  const result: any = {
    steamShipRatePerPound: divide(Number(data.steamShipRate ?? 0)),
    dutyAndEntryPerPound: divide(Number(data.dutyAndEntry ?? 0)),
    marineInsurancePerPound: divide(totalCost * Number(data.marineInsurance ?? 0) / 100),
    drayagePerPound: divide(Number(data.drayage ?? 0)),
    strippingPerPound: divide(Number(data.stripping ?? 0) * bags),
    storagePerPound: divide(Number(data.storage ?? 0) * bags),
    weighingPerPound: divide(Number(data.weighing ?? 0) * bags),
    financingPerPound: pounds > 0 ? cost * Number(data.financing ?? 0) / 100 / 360 * Number(data.DaysToFinance ?? 0) : 0,
    fotPerPound: Number(data.fot ?? 0),
    sampleChargePerPound: divide(Number(data.sampleCharge ?? 0)),
    rfaPerPound: Number(data.rfa ?? 0)
  };
  result.totalEstimate = pounds > 0 ? Object.values(result).reduce((sum: number, amount: any) => sum + amount, 0)
    + (data.TariffInPrice ? 0 : Number(data.TariffAmount ?? 0)) : 0;
  return result;
}
